import React from 'react';
import { Form, Input, Button, Typography, Row, Col, Card } from 'antd';
import { MailOutlined, PhoneOutlined, EnvironmentOutlined, UserOutlined, MessageOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { API_BASE_URL } from '../utils/BaseUrl';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';



const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;


const PageHeader = styled.div`
  background: linear-gradient(to right, rgba(241, 86, 55, 0.85), rgba(251, 168, 64, 0.85));
  padding: 60px 0;
  color: white;
  text-align: center;
  margin-bottom: 40px;
`;

const ContactContainer = styled.div`
  padding: 0 24px 60px;
  
  @media (max-width: 768px) {
    padding: 0 16px 40px;
  }
`;

const ContactCard = styled(Card)`
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 24px;
  }
`;

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  background: linear-gradient(to right, #F15637, #FBA840);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: white;
  font-size: 24px;
`;


const ContactPage = () => {
  const navigate = useNavigate();

  const onFinish = async (values) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.userId;

  if (!userId) {
    Swal.fire({
      icon: 'warning',
      title: 'Chưa đăng nhập!',
      text: 'Vui lòng đăng nhập để gửi liên hệ.',
    })
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/ContactForm/createContactForm?userId=${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(values)
    });

    if (response.ok) {
      const result = await response.json();
      console.log('Form submitted successfully:', result);

      Swal.fire({
        icon: 'success',
        title: 'Gửi thành công!',
        text: 'Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi sớm.',
      }).then(() => {
        navigate('/');
      });

    } else {
      console.error('Submission failed:', response.status);

      Swal.fire({
        icon: 'error',
        title: 'Thất bại!',
        text: 'Đã có lỗi xảy ra. Vui lòng thử lại sau.',
      });
    }
  } catch (error) {
    console.error('Error submitting form:', error);

    Swal.fire({
      icon: 'error',
      title: 'Lỗi kết nối!',
      text: 'Không thể kết nối đến máy chủ. Vui lòng thử lại sau.',
    });
  }
};




  return (
    <>
      <PageHeader>
        <div className="container">
          <Title level={1} style={{ color: 'white', marginBottom: 16 }}>
            Liên hệ với chúng tôi
          </Title>
          <Text style={{ color: 'white', fontSize: 18 }}>
            Hãy liên hệ với đội ngũ Mixi Fitness nếu bạn có bất kỳ câu hỏi hoặc thắc mắc nào
          </Text>
        </div>
      </PageHeader>
      
      <ContactContainer className="container">
        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} md={8}>
            <ContactCard>
              <IconWrapper>
                <PhoneOutlined />
              </IconWrapper>
              <Title level={4}>Số điện thoại</Title>
              <Paragraph>Hỗ trợ & tư vấn nhanh</Paragraph>
              <Text strong>+84 123 456 789</Text>
            </ContactCard>
          </Col>
          
          <Col xs={24} md={8}>
            <ContactCard>
              <IconWrapper>
                <MailOutlined />
              </IconWrapper>
              <Title level={4}>Email</Title>
              <Paragraph>Gửi thắc mắc & hỗ trợ</Paragraph>
              <Text strong>info@mixifitness.com</Text>
            </ContactCard>
          </Col>
          
          <Col xs={24} md={8}>
            <ContactCard>
              <IconWrapper>
                <EnvironmentOutlined />
              </IconWrapper>
              <Title level={4}>Địa chỉ</Title>
              <Paragraph>Văn phòng chính</Paragraph>
              <Text strong>Khu đô thị K, Đại học FPT Đà Nẵng</Text>
            </ContactCard>
          </Col>
        </Row>
        
        <div style={{ maxWidth: 800, margin: '60px auto 0' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: 48 }}>
            Gửi tin nhắn cho chúng tôi
          </Title>
          
          <Form
            name="contact_form"
            layout="vertical"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  rules={[{ required: true, message: 'Vui lòng nhập tên của bạn' }]}
                >
                  <Input 
                    prefix={<UserOutlined />} 
                    placeholder="Tên của bạn" 
                    size="large" 
                  />
                </Form.Item>
              </Col>
              
              <Col xs={24} md={12}>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Vui lòng nhập email' },
                    { type: 'email', message: 'Email không hợp lệ' }
                  ]}
                >
                  <Input 
                    prefix={<MailOutlined />} 
                    placeholder="Email của bạn" 
                    size="large" 
                  />
                </Form.Item>
              </Col>
            </Row>
            
            <Form.Item
              name="subject"
              rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
            >
              <Input 
                placeholder="Tiêu đề" 
                size="large" 
              />
            </Form.Item>
            
            <Form.Item
              name="message"
              rules={[{ required: true, message: 'Vui lòng nhập nội dung tin nhắn' }]}
            >
              <TextArea 
                prefix={<MessageOutlined />}
                placeholder="Nội dung tin nhắn" 
                rows={6}
              />
            </Form.Item>
            
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{ height: 48, minWidth: 120 }}
              >
                Gửi tin nhắn
              </Button>
            </Form.Item>
          </Form>
        </div>
      </ContactContainer>
      
      {/* Có thể thêm bản đồ vị trí tại đây nếu muốn */}
    </>
  );
};

export default ContactPage;